"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const meetingVotingHistory = (0, graphql_tag_1.default)`
  ${data_1.documentSchemaFields}
  query meetings_meeting_voting_history(
    $bulletinId: Int
    $meetingId: Int!
    $before: Int
    $after: Int
    $first: Int
    $last: Int
  ) {
    meetings {
      meeting {
        voting {
          history(
            bulletinId: $bulletinId
            meetingId: $meetingId
            before: $before
            after: $after
            first: $first
            last: $last
          ) {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            edges {
              node {
                id
                body
                date
                template
                values
                historyType
                isRead
                documents {
                  ...documentSchemaFields
                }
                bodyDocuments {
                  ...documentSchemaFields
                }
                user {
                  accessLevel
                  avatarColor
                  avatarBorderColor
                  avatarText
                  avatarDisplayName
                  avatarUrl
                  firstName
                  fullName
                  hasPrivateProfile
                  id
                  isRegistered
                  juristicPersonLegalForm
                  juristicPersonName
                  lastName
                  membership
                  personType
                  role
                  showMyAvatar
                  active
                }
                targetUsers {
                  accessLevel
                  avatarColor
                  avatarBorderColor
                  avatarText
                  avatarDisplayName
                  avatarUrl
                  firstName
                  fullName
                  hasPrivateProfile
                  id
                  isRegistered
                  juristicPersonLegalForm
                  juristicPersonName
                  lastName
                  membership
                  personType
                  role
                  showMyAvatar
                }
              }
            }
          }
        }
      }
    }
  }
`;
exports.default = meetingVotingHistory;